import Vue from "vue";
import VueI18n from "vue-i18n";

import elementRu from "element-ui/lib/locale/lang/ru-RU";
import elementUa from "element-ui/lib/locale/lang/ua";
import elementEn from "element-ui/lib/locale/lang/en";
import elementEs from "element-ui/lib/locale/lang/es";

import commonRu from "./ru/common";
import signinRu from "./ru/signin";
import homeRu from "./ru/home";
import bankpayRu from "./ru/bankpay";
import packsreceiptsRu from "./ru/packsreceipts";
import relationshipRu from "./ru/relationship";
import assignoperatorsRu from "./ru/assignoperators";
import controlpacksRu from "./ru/controlpacks";
import controlinetpaysRu from "./ru/controlinetpays";
import paymentRu from "./ru/payment";
import subscribesRu from "./ru/subscribers";
import enteringpaymentsRu from "./ru/enteringpayments";
import enteringsubsidiesRu from "./ru/enteringsubsidies";
import gridcontextmenuRu from "./ru/gridcontextmenu";
import packsRu from "./ru/packs";
import errorPaymentsRu from "./ru/errorPayments";
import settingsRu from "./ru/settings";
import acceptedshipmentRu from "./ru/acceptedshipment";

import commonUa from "./ua/common";
import signinUa from "./ua/signin";
import homeUa from "./ua/home";
import bankpayUa from "./ua/bankpay";
import packsreceiptsUa from "./ua/packsreceipts";
import relationshipUa from "./ua/relationship";
import assignoperatorsUa from "./ua/assignoperators";
import controlpacksUa from "./ua/controlpacks";
import controlinetpaysUa from "./ua/controlinetpays";
import paymentUa from "./ua/payment";
import subscribesUa from "./ua/subscribers";
import enteringpaymentsUa from "./ua/enteringpayments";
import enteringsubsidiesUa from "./ua/enteringsubsidies";
import gridcontextmenuUa from "./ua/gridcontextmenu";
import packsUa from "./ua/packs";
import errorPaymentsUa from "./ua/errorPayments";
import settingsUa from "./ua/settings";
import acceptedshipmentUa from "./ua/acceptedshipment";

import commonEn from "./en/common";
import signinEn from "./en/signin";
import homeEn from "./en/home";
import bankpayEn from "./en/bankpay";
import packsreceiptsEn from "./en/packsreceipts";
import relationshipEn from "./en/relationship";
import assignoperatorsEn from "./en/assignoperators";
import controlpacksEn from "./en/controlpacks";
import controlinetpaysEn from "./en/controlinetpays";
import paymentEn from "./en/payment";
import subscribesEn from "./en/subscribers";
import enteringpaymentsEn from "./en/enteringpayments";
import enteringsubsidiesEn from "./en/enteringsubsidies";
import gridcontextmenuEn from "./en/gridcontextmenu";
import packsEn from "./en/packs";
import errorPaymentsEn from "./en/errorPayments";
import settingsEn from "./en/settings";
import acceptedshipmentEn from "./en/acceptedshipment";

import commonEs from "./es/common";
import signinEs from "./es/signin";
import homeEs from "./es/home";
import bankpayEs from "./es/bankpay";
import packsreceiptsEs from "./es/packsreceipts";
import relationshipEs from "./es/relationship";
import assignoperatorsEs from "./es/assignoperators";
import controlpacksEs from "./es/controlpacks";
import controlinetpaysEs from "./es/controlinetpays";
import paymentEs from "./es/payment";
import subscribesEs from "./es/subscribers";
import enteringpaymentsEs from "./es/enteringpayments";
import enteringsubsidiesEs from "./es/enteringsubsidies";
import gridcontextmenuEs from "./es/gridcontextmenu";
import packsEs from "./es/packs";
import errorPaymentsEs from "./es/errorPayments";
import settingsEs from "./es/settings";
import acceptedshipmentEs from "./es/acceptedshipment";

Vue.use(VueI18n);

const messages = {
  ru: {
    ...elementRu,
    ...commonRu,
    ...signinRu,
    ...homeRu,
    ...bankpayRu,
    ...packsreceiptsRu,
    ...relationshipRu,
    ...assignoperatorsRu,
    ...controlpacksRu,
    ...controlinetpaysRu,
    ...paymentRu,
    ...subscribesRu,
    ...enteringpaymentsRu,
    ...enteringsubsidiesRu,
    ...gridcontextmenuRu,
    ...packsRu,
    ...errorPaymentsRu,
    ...settingsRu,
    ...acceptedshipmentRu
  },
  ua: {
    ...elementUa,
    ...commonUa,
    ...signinUa,
    ...homeUa,
    ...bankpayUa,
    ...packsreceiptsUa,
    ...relationshipUa,
    ...assignoperatorsUa,
    ...controlpacksUa,
    ...controlinetpaysUa,
    ...paymentUa,
    ...subscribesUa,
    ...enteringpaymentsUa,
    ...enteringsubsidiesUa,
    ...gridcontextmenuUa,
    ...packsUa,
    ...errorPaymentsUa,
    ...settingsUa,
    ...acceptedshipmentUa
  },
  en: {
    ...elementEn,
    ...commonEn,
    ...signinEn,
    ...homeEn,
    ...bankpayEn,
    ...packsreceiptsEn,
    ...relationshipEn,
    ...assignoperatorsEn,
    ...controlpacksEn,
    ...controlinetpaysEn,
    ...paymentEn,
    ...subscribesEn,
    ...enteringpaymentsEn,
    ...enteringsubsidiesEn,
    ...gridcontextmenuEn,
    ...packsEn,
    ...errorPaymentsEn,
    ...settingsEn,
    ...acceptedshipmentEn
  },
  es: {
    ...elementEs,
    ...commonEs,
    ...signinEs,
    ...homeEs,
    ...bankpayEs,
    ...packsreceiptsEs,
    ...relationshipEs,
    ...assignoperatorsEs,
    ...controlpacksEs,
    ...controlinetpaysEs,
    ...paymentEs,
    ...subscribesEs,
    ...enteringpaymentsEs,
    ...enteringsubsidiesEs,
    ...gridcontextmenuEs,
    ...packsEs,
    ...errorPaymentsEs,
    ...settingsEs,
    ...acceptedshipmentEs
  }
};

const localeBrowser = navigator.language.split("-")[0];
let checkLocale = ["ru", "uk", "en", "es"].includes(localeBrowser)
  ? localeBrowser
  : "ru";
const setLocale = checkLocale === "uk" ? "ua" : checkLocale;

export default new VueI18n({
  locale: setLocale,
  fallbackLocale: setLocale,
  messages
});
